import { Constants } from "@core/Utils/Constants";
import { BackgroundBlockInput } from "./Utils/BackgroundBlockInput";
import { Language, Messages } from "./Language";
import { Client } from "@core/Client";

export class WinReport {
    Callback = () => { }
    private targetX = 0
    private targetY = 0
    private savedAvailableWidth = 0
    private savedAvailableHeight = 0
    private backgroundBlockInput: BackgroundBlockInput
    private dom: Phaser.GameObjects.DOMElement
    private html = `<div class="win-report-window">
                        <div class="win-report-scrollable"> </div>
                    </div>`

    constructor(private scene: Phaser.Scene) {
        this.backgroundBlockInput = new BackgroundBlockInput(scene)
        this.scene.add.existing(this.backgroundBlockInput)

        this.scene.game.events.addListener("winReport", (reportData: any) => {
            this.generate(reportData)
        })
    }

    get DOM(): Phaser.GameObjects.DOMElement {
        return this.dom
    }

    Resize(width: number, height: number): void {
        // Remove all win report HTML in case of portrait mode
        if (this.dom && this.scene.scale.width < this.scene.scale.height) this.dom.setHTML('')

        this.savedAvailableWidth = width
        this.savedAvailableHeight = height
    }

    Position(x: number, y: number): void {
        this.targetX = x
        this.targetY = y
    }

    private generate(reportData: { "registeredPlayers": number, "totalWon": number, "winList": {}, "winningPlayers": { "registeredPlayers": number, "totalWon": number } }): void {
        if (!this.dom) {
            this.dom = this.scene.add.dom(0, 0).createFromHTML(this.html)
            this.dom.setOrigin(0)
            this.dom.addListener('click')
            this.dom.on('click', this.handler, this)
            // Stacking context issues fix (brings up the z-index of Phaser DOM Eelementholder)
            this.dom.node.parentElement.style.zIndex = "1"
        }

        if (this.scene.scale.width < this.scene.scale.height) {
            this.dom.setHTML('')
            return
        }

        let numberOfWinners = Object.keys(reportData.winList).length

        if (numberOfWinners <= 0) {
            this.dom.setHTML('')
            return
        }

        let winnerList = []
        for (let i = 0; i < Object.keys(reportData.winList).length; i++) {
            let player = Client.logic.setup.PlayerList.find(x => x.id == Object.keys(reportData.winList)[i])
            if (player && player.nickname) winnerList.push({ name: player.nickname, amount: reportData.winList[Object.keys(reportData.winList)[i]] })
        }

        winnerList.sort((a, b) => b.amount - a.amount)

        // Amount / 100 because the number received is in cents!
        let totalWon = reportData.totalWon / Client.logic.CurrencyValue / 100

        // this.dom.setHTML('<div class="win-report-window"><div id="win-report-relative"><div id="win-report-scrollable">'+this.createSumHeaderString("250", reportData.totalWon) + this.generateWinnersString(fakeWinners)+'</div></div></div>')
        this.dom.setHTML(`
            <div class="win-report-window" id="win-report-window-id">
                <div class="win-report-inner-wrap">
                    <div class="win-report-outer">
                        <div id="win-report-relative">
                            <div id="win-report-scrollable"> ${this.createSumHeaderString(numberOfWinners + "", totalWon)} ${this.generateWinnersString(winnerList)} </div>
                        </div>
                    </div>                        
                </div>
            </div>
        `)

        let winReportWindowElement = document.getElementById('win-report-window-id')
        winReportWindowElement.style.width = this.savedAvailableWidth + "px"
        winReportWindowElement.style.height = this.savedAvailableHeight + "px"

        // document.getElementById('win-report-scrollable').style.transition = "transform 35.5s linear 0s"

        // Scale will be affected by our quality (q=0.80) query parameter thus making this.scene.scale.height size of canvas, read window.innerHeight instead
        // document.getElementById('win-report-scrollable').style.transform = 'translate3d(0px, -' + window.innerHeight * window.devicePixelRatio * 2 + 'px, 0px)'

        // this.dom.setPosition(0, this.scene.scale.height/2)
        let repositionWinReportToVideo = true
        if (repositionWinReportToVideo) {
            document.getElementById('win-report-scrollable').style.transition = "transform 10.5s linear 0s"
            let iframe_container = document.getElementById('iframe_container')

            // Bottom padding to prevent win report from bleeding over the edge of the iframe container
            let bottomPadding = 5

            // Side margin to offset the video to the right from the edge of the iframe container
            let sideMargin = 5

            winReportWindowElement.style.width = iframe_container.clientWidth + "px"
            winReportWindowElement.style.height = (iframe_container.clientHeight - bottomPadding) + "px"
            winReportWindowElement.style.zIndex = "999"

            iframe_container.appendChild(winReportWindowElement)
            // Must change transform after appending the child DIV!
            document.getElementById('win-report-scrollable').style.transform = 'translate3d(0px, -' + iframe_container.clientHeight * window.devicePixelRatio * 2 + 'px, 0px)'
            document.getElementById('win-report-scrollable').style.marginLeft = sideMargin + 'px'
        } else {
            document.getElementById('win-report-scrollable').style.transition = "transform 35.5s linear 0s"
            document.getElementById('win-report-scrollable').style.transform = 'translate3d(0px, -' + window.innerHeight * window.devicePixelRatio * 2 + 'px, 0px)'
            this.dom.setPosition(this.targetX + this.scene.scale.width * Constants.PANEL.MARGIN * (this.scene.game.device.os.android || this.scene.game.device.os.iOS ? 2 : 1), this.targetY)
        }

        setTimeout(() => {
            if (document.getElementsByClassName('win-report-outer')[0]) {
                (document.getElementsByClassName('win-report-outer')[0] as HTMLElement).style.opacity = "0"
            }
            setTimeout(() => {
                if (repositionWinReportToVideo) {
                    winReportWindowElement.remove()
                }
                this.dom.setHTML('')
            }, 1000);
        }, 7000);

        return
    }

    private createSumHeader(winners: string, sum: number): HTMLElement {
        let sumHeader = document.createElement("P")
        sumHeader.className = "win-report-total-header"

        let totalPlayers = document.createElement("SPAN")
        totalPlayers.className = "win-report-total-players"
        let totalPlayersText = document.createTextNode(winners + " ")
        totalPlayers.appendChild(totalPlayersText)

        let playerImage = document.createElement("IMG");
        playerImage.style.verticalAlign = "text-bottom";
        playerImage.style.width = "39px";
        playerImage.style.filter = "invert(1)";
        (playerImage as HTMLImageElement).src = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB3aWR0aD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI0IDhjLTQuNDIgMC04IDMuNTgtOCA4IDAgNC40MSAzLjU4IDggOCA4czgtMy41OSA4LThjMC00LjQyLTMuNTgtOC04LTh6bTAgMjBjLTUuMzMgMC0xNiAyLjY3LTE2IDh2NGgzMnYtNGMwLTUuMzMtMTAuNjctOC0xNi04eiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==";

        let totalWon = document.createElement("SPAN")
        totalWon.className = "win-report-total-won"
        let totalWonText = document.createTextNode(Language.InternationalNumberFormat.format(sum))
        totalWon.appendChild(totalWonText)

        sumHeader.appendChild(totalPlayersText)
        sumHeader.appendChild(playerImage)
        sumHeader.appendChild(document.createTextNode(" " + Language.Get(Messages.X_PLAYERS_WON) + " "))
        sumHeader.appendChild(totalWon)

        return sumHeader
    }

    // Functions with String are used with Phaser DOM GameObject
    private createSumHeaderString(winners: string, sum: number): string {
        // img width was previously 39px, now it is percentage based
        let html = `<p class="win-report-total-header">`
        html += `<span class="win-report-total-players">${winners} 
                <img style="width: 10%; height: 28px; vertical-align: top; filter: invert(1);" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB3aWR0aD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI0IDhjLTQuNDIgMC04IDMuNTgtOCA4IDAgNC40MSAzLjU4IDggOCA4czgtMy41OSA4LThjMC00LjQyLTMuNTgtOC04LTh6bTAgMjBjLTUuMzMgMC0xNiAyLjY3LTE2IDh2NGgzMnYtNGMwLTUuMzMtMTAuNjctOC0xNi04eiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==" />
                ${Language.Get(Messages.X_PLAYERS_WON)}
                <span class="win-report-total-won">${Language.InternationalNumberFormat.format(sum)}</span>
                </span>`
        html += `</p>`
        return html
    }

    private generateWinners(winners: any[]): HTMLElement {
        let winnersDIV = document.createElement("DIV")
        for (let i = 0; i < winners.length; i++) {
            let winner = winners[i]
            if (i < 3) {
                let p = document.createElement("P")
                p.className = "win-report-top-players"
                let winnerAmountText = document.createTextNode(Language.InternationalNumberFormat.format((winner.amount / Client.logic.CurrencyValue / 100)))
                let winnerNameText = document.createTextNode("  " + winner.name)
                p.appendChild(winnerAmountText)
                p.appendChild(winnerNameText)
                winnersDIV.appendChild(p)
            } else {
                let p = document.createElement("P")
                p.className = "win-report-normal-players"
                let winnerAmountText = document.createTextNode(Language.InternationalNumberFormat.format((winner.amount / Client.logic.CurrencyValue / 100)))
                let winnerNameText = document.createTextNode("  " + winner.name)
                p.appendChild(winnerAmountText)
                p.appendChild(winnerNameText)
                winnersDIV.appendChild(p)
            }
        }
        return winnersDIV
    }

    private generateWinnersString(winners: any[]): string {
        let html = `<div>`
        for (let i = 0; i < winners.length; i++) {
            let winner = winners[i]
            if (i < 3) {
                html += `<p class="win-report-top-players">
                    ${Language.InternationalNumberFormat.format((winner.amount / Client.logic.CurrencyValue / 100))} ${winner.name}
                </p>
                `
            } else {
                html += `<p class="win-report-normal-players">
                    ${Language.InternationalNumberFormat.format((winner.amount / Client.logic.CurrencyValue / 100))} ${winner.name}
                </p>
                `
            }
        }
        html += `</div>`
        return html
    }

    private handler(event: any) {
        event.stopImmediatePropagation()
        event.stopPropagation()
        event.preventDefault()

        if (event.target.className == "help-title-close-button" || event.target.className == "help-title") {
            this.Callback()
        }
    }
}
